import axios from 'axios'

export default class {
  _fiel
  _validateFielUrl
  _additionalConfig
  constructor(fiel) {
    this._validateFielUrl = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_VALIDATE_FIEL_OPERATION}`
    this._fiel = fiel
    this._additionalConfig = {
      headers: {
        'x-api-key': `${process.env.VUE_APP_API_PRIMARY_API_KEY}`
      }
    }
  }

  validateRootCertificates() {
    const jsonData = {
      'certificado': this._fiel.certificateBase64
    }
    return axios.post(this._validateFielUrl, jsonData, this._additionalConfig)
  }
}
